import { render, staticRenderFns } from "./EditDownloadSettingsModal.vue?vue&type=template&id=0bd15438"
import script from "./EditDownloadSettingsModal.vue?vue&type=script&lang=js"
export * from "./EditDownloadSettingsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports